import "core-js/modules/es6.array.map";
import React from 'react';
import MenuItem, { menuItemPropType } from '../../02-molecules/menus/MenuItem.component';
import bem from '../../_utils/bem';

var Menu = function Menu(_ref) {
  var _ref$block = _ref.block,
      block = _ref$block === void 0 ? 'menu' : _ref$block,
      element = _ref.element,
      _ref$modifiers = _ref.modifiers,
      modifiers = _ref$modifiers === void 0 ? [] : _ref$modifiers,
      level = _ref.level,
      items = _ref.items;
  var mods = [].concat(modifiers, level ? ['sub', "sub-" + level] : []);
  return /*#__PURE__*/React.createElement("ul", {
    className: bem(block, element, mods)
  }, items && items.map(function (_ref2, id) {
    var title = _ref2.title,
        url = _ref2.url,
        below = _ref2.below;
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: id,
      block: block,
      title: title,
      url: url,
      sublinks: below,
      modifiers: mods
    });
  }));
};

export default Menu;